module.exports = __webpack_public_path__ + "img/pic_login.ab25d791.png";